<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <p class=".title ma-2">Password reset for {{eign.eign_code}} {{eign.eign_naam}}</p>
    <v-form ref="updEignPassword" v-model="updEignPasswordValid">
     
     
     <v-row no-gutters class="mx-2">  
        <v-col cols="6" class="mx-2">
          <v-text-field
                            v-model="eign.eign_password"
                            :rules="eign_passwordRules"
                            label="Password"
                            dense
                          ></v-text-field>
       </v-col>
     </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="updEignPassword" :disabled="!updEignPasswordValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      updEignPasswordValid: false,
      eign_encrid: null,
      eign_passwordRules: [(v) => (v && v.length >= 8) || "A minimal length of 8 char is required"],
      eign: {}
    }
  },
  methods: {
    open(eign_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.eign_encrid = eign_encrid;
      this.$axios
        .post("ares/json/ares/eign/getEignToUpdPassword.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getEignToUpdPassword"
          },
          getEignToUpdPassword: {
            eign_encrid: eign_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.eign = res.data.getEignToUpdPassword;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updEignPassword() { 
      this.$axios
        .post("ares/json/ares/eign/updEignPassword.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updEignPassword"
          },
          updEignPassword: {
            eign_encrid: this.eign.eign_encrid,
            eign_password: this.eign.eign_password
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.updEignPassword.text,
                color: res.data.updEignPassword.color,
              });
              this.dialog = false;
          }
        })
    }
  }
}
</script>

